import React from 'react'
import { createCartUrl } from '../utils/cart'
import ShoppingCart from '../images/icons/shopping-cart.svg'

import {
  CtaBar,
  LeshenPhoneCTA,
  LinkButton,
  useMapi,
} from '@leshen/gatsby-theme-leshen'

function SeoCtaBar() {
  const { rotatedNumber, sessionPromoCode, requestId } = useMapi()
  const cartURL = createCartUrl(rotatedNumber, sessionPromoCode, requestId)

  return (
    <CtaBar
      backgroundColor="primary"
      textColor="white"
      sticky
      leftBlock={
        <LeshenPhoneCTA
          outlined
          color="light"
          cobra="Hide CTA"
          requestId={requestId}
          cobraCartUrl={cartURL}
        >
          Call:
        </LeshenPhoneCTA>
      }
      middleBlock={
        <LinkButton
          outlined
          color="light"
          to={cartURL}
          requestId={requestId}
          leftIcon={<img src={ShoppingCart} alt="shopping cart icon" />}
        >
          Order Online
        </LinkButton>
      }
    />
  )
}

export default SeoCtaBar
